import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import * as Actions from "./actions";
import * as Api from "./api";

function* loadGameRequestHandler(action) {
  try {
    const { response } = yield call(Api.loadGame, action.payload.token);
    yield put(Actions.loadGame.success(response));
  } catch (error) {
    yield put(Actions.loadGame.failure(error));
  }
}

function* loadGamesRequestHandler(action) {
  try {
    const { response } = yield call(Api.loadGames, action.payload.lang);
    yield put(Actions.loadGames.success(response));
  } catch (error) {
    yield put(Actions.loadGames.failure(error));
  }
}

function* prepareGameRequestHandler(action) {
  try {
    const { response } = yield call(
      Api.prepareGame,
      action.payload.id,
      action.payload.user_id,
      action.payload.token,
      action.payload.lang,
    );
    yield put(Actions.prepareGame.success(response, action.payload.token));
    // yield call([history, history.push], '/games/play');
  } catch (error) {
    yield put(Actions.loadGame.failure(error));
  }
}

function* watchLoadGameRequest() {
  yield takeLatest(Actions.GAME.REQUEST, loadGameRequestHandler);
}

function* watchLoadGamesRequest() {
  yield takeLatest(Actions.GAMES.REQUEST, loadGamesRequestHandler);
}

function* watchPrepareGameRequest() {
  yield takeLatest(Actions.PREPARE_GAME.REQUEST, prepareGameRequestHandler);
}

export default function* gameSagas() {
  yield all([fork(watchLoadGameRequest), fork(watchLoadGamesRequest), fork(watchPrepareGameRequest)]);
}
